export default class HeaderVideo {
    constructor(element) {
        var _a, _b, _c;
        this.element = element;
        this.isAudible = false;
        this.toggle = (_a = this.element.querySelector("[data-header-video-control]")) !== null && _a !== void 0 ? _a : document.createElement("button");
        this.video = (_b = this.element.querySelector("[data-responsive-video]")) !== null && _b !== void 0 ? _b : document.createElement("video");
        this.icon = (_c = this.element.querySelector("[data-header-video-control-icon]")) !== null && _c !== void 0 ? _c : document.createElement("use");
        this.init();
    }
    init() {
        this.toggle.addEventListener("click", this.toggleState.bind(this));
    }
    toggleState() {
        if (this.isAudible) {
            this.video.muted = true;
            this.toggle.classList.remove("active");
            this.icon.setAttribute("xlink:href", "#speaker-off");
            this.isAudible = false;
            return true;
        }
        this.video.muted = false;
        this.toggle.classList.add("active");
        this.icon.setAttribute("xlink:href", "#speaker-on");
        this.isAudible = true;
        return true;
    }
}
